const zonesNamesRefs = new Map([
  [ 'neighborhoods', {name: 'Barrio', color: 'purple'} ],
  [ 'communes', {name: 'Comuna', color: 'amber'} ],
  [ 'quadrants', {name: 'Cuadrante', color: 'light-green'} ],
  [ 'stations', {name: 'Estación', color: 'cyan'} ],
  [ 'districts', {name: 'Distrito', color: 'deep-purple'} ],
  [ 'firefighters', {name: 'Bomberos', color: 'red darken-1'} ],
  [ 'empas', {name: 'EMPAS', color: 'orange darken-2'} ]
])

export {zonesNamesRefs}



// WEBPACK FOOTER //
// ./src/utils/zonesHelpers.js